import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Radio, Loader2, ShieldCheck } from "lucide-react";
import { toast } from "sonner";

export default function ForcePasswordChange() {
  const { setUser, logout } = useAuth();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (pw.length < 8) { setError("Password must be at least 8 characters"); return; }
    if (pw !== pw2) { setError("Passwords don't match"); return; }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { new_password: pw });
      const { data } = await api.get("/auth/me");
      setUser(data);
      toast.success("Password set — welcome to CommConnect");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally { setBusy(false); }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-6" data-testid="force-password-page">
      <div className="w-full max-w-sm">
        <div className="mb-6 flex items-center gap-2">
          <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary text-primary-foreground"><Radio className="h-5 w-5" /></div>
          <span className="font-heading text-xl font-bold">CommConnect</span>
        </div>
        <div className="mb-4 flex items-center gap-2 text-primary"><ShieldCheck className="h-5 w-5" /><h2 className="font-heading text-2xl font-bold">Set your password</h2></div>
        <p className="mb-5 text-sm text-muted-foreground">Welcome! For your security, please choose your own password before continuing.</p>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label htmlFor="np">New password</Label>
            <Input id="np" type="password" value={pw} onChange={(e) => setPw(e.target.value)} className="mt-1.5" data-testid="force-pw" required />
          </div>
          <div>
            <Label htmlFor="np2">Confirm password</Label>
            <Input id="np2" type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} className="mt-1.5" data-testid="force-pw2" required />
          </div>
          {error && <p className="text-sm text-destructive" data-testid="force-error">{error}</p>}
          <Button type="submit" disabled={busy} className="w-full rounded-full" data-testid="force-submit">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Save password & continue"}
          </Button>
          <button type="button" onClick={logout} className="w-full text-center text-xs text-muted-foreground hover:underline" data-testid="force-signout">Sign out</button>
        </form>
      </div>
    </div>
  );
}
